import { render, staticRenderFns } from "./DeleteGroupModal.vue?vue&type=template&id=39e907ae&"
import script from "./DeleteGroupModal.vue?vue&type=script&lang=js&"
export * from "./DeleteGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports